import { render, staticRenderFns } from "./buyer.vue?vue&type=template&id=6e2dc422&"
import script from "./buyer.vue?vue&type=script&lang=js&"
export * from "./buyer.vue?vue&type=script&lang=js&"
import style0 from "./buyer.vue?vue&type=style&index=0&id=6e2dc422&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e2dc422')) {
      api.createRecord('6e2dc422', component.options)
    } else {
      api.reload('6e2dc422', component.options)
    }
    module.hot.accept("./buyer.vue?vue&type=template&id=6e2dc422&", function () {
      api.rerender('6e2dc422', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/buyer.vue"
export default component.exports